var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMageShop({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.1668 6.62922C14.166 7.0535 14.0338 7.46712 13.7884 7.8132C13.5429 8.15928 13.1963 8.42083 12.7962 8.56189C12.5773 8.64406 12.3453 8.68585 12.1115 8.68522C11.6872 8.68442 11.2736 8.55221 10.9275 8.30677C10.5814 8.06133 10.3199 7.7147 10.1788 7.31455C10.0966 7.09546 10.0548 6.86325 10.0555 6.62922C10.0575 6.86322 10.0155 7.09589 9.93216 7.31455C9.79114 7.71459 9.52969 8.06114 9.18374 8.30658C8.8378 8.55201 8.42433 8.68429 8.00016 8.68522C7.576 8.68429 7.16253 8.55201 6.81658 8.30658C6.47063 8.06114 6.20918 7.71459 6.06816 7.31455C5.98591 7.09546 5.94412 6.86325 5.94483 6.62922C5.94616 6.86322 5.90483 7.09589 5.8215 7.31455C5.68044 7.7147 5.41889 8.06133 5.07281 8.30677C4.72672 8.55221 4.31311 8.68442 3.88883 8.68522C3.6555 8.68655 3.42216 8.64522 3.20416 8.56189C2.80402 8.42083 2.45739 8.15928 2.21195 7.8132C1.9665 7.46712 1.83429 7.0535 1.8335 6.62922L2.1415 5.54722L2.8815 3.43655C2.97579 3.16825 3.15104 2.93584 3.38307 2.77141C3.61509 2.60697 3.89244 2.51862 4.17683 2.51855H11.8235C12.1078 2.51876 12.385 2.60717 12.6169 2.7716C12.8488 2.93603 13.0239 3.16836 13.1182 3.43655L13.8582 5.54722L14.1668 6.62922Z",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.796 8.56152V12.1109C12.7958 12.4741 12.6514 12.8225 12.3945 13.0794C12.1376 13.3363 11.7893 13.4807 11.426 13.4809H4.5733C4.39334 13.4809 4.21512 13.4456 4.04882 13.3768C3.88253 13.308 3.73142 13.2071 3.60414 13.0798C3.47685 12.9526 3.37588 12.8015 3.30699 12.6353C3.23809 12.469 3.20264 12.2908 3.20264 12.1109V8.56152",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMageShop);
export default __webpack_public_path__ + "static/media/mage_shop.310256f32fc4adf6d94d3b89d0f10425.svg";
export { ForwardRef as ReactComponent };